
































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import WalletKey from "@/components/wallet-key";

// const gravBaseUrl = process.env.VUE_APP_GRAV_BASE_URL;
const gravBaseUrl = 'https://g.cyurica.biz/cyurica/'

export default createComponent({
  setup(props: {}, context: SetupContext) {

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }

    const globalStore = context.root.$store;
    const accessToken = computed(() => globalStore.auth.token);
    const walletList = computed(() => walletStore.walletList);

    const loadedFlag = ref<boolean>(false);

    const companyOneTimeWithdrawalLimit = computed(() => memberStore.companyOneTimeWithdrawalLimit);

    onMounted(async () => {
      loadedFlag.value = true;
      walletStore.clearResponse();
      memberStore.setAuthorizationHeader(accessToken.value);
      walletStore.setAuthorizationHeader(accessToken.value);
      await walletStore.getWalletList();
      await memberStore.getCompanyOneTimeWithdrawalLimit(walletList.value[0]['company_code_item']['internal_value']);
      loadedFlag.value = false;
    });


    return {
      gravBaseUrl,
      companyOneTimeWithdrawalLimit,
      loadedFlag
    };
  },
  components: {}
});
